import { render, staticRenderFns } from "./FilePanel.vue?vue&type=template&id=db2344d4"
import script from "./FilePanel.vue?vue&type=script&lang=js"
export * from "./FilePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports